export default __webpack_public_path__ + "step-list-section.png";